<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <strong>* 管理者アクセスIP、API IPなど、重要なもの、例外的に処理する必要があるものを設定します。</strong>
        <hr>
        <strong>* 例 : 1行に、1つのIPを入力します。</strong>
        <br>
        <br>
        <span>111.222.111.222</span><br><span>111.222.111.222</span>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col :sm="is_setup ? '12' : '6'">
        <strong>許可IP</strong> : <span>許可するIPを書き込む</span>(* オールバイパス)
        <b-button class="pull-right" size="sm" variant="outline-info" @click="explain_ip_allow = true"><i class="fa fa-question"></i></b-button>
        <hr>
        <b-form-group>
          <b-form-textarea @update="allow_ip($event, 'allow_ip')" @change="allow_ip" v-model="model.allow_ip" :row="10" :max-rows="50"></b-form-textarea>
        </b-form-group>
      </b-col>
      <!-- is_setup 사용, 아직 블럭할 ip 를 구분할 수 없을 것임 -->
      <b-col sm="6" v-if="!is_setup">
        <strong>
          <!-- <b-badge v-if="server.mode == 'DetectionOnly' || server.mode == 1" variant="warning">Detection</b-badge>
          <b-badge v-else-if="server.mode == 'On' || server.mode == 2" variant="danger">Block</b-badge>
          <span v-else>-</span> -->
          ブロックIP : <span class="text-danger">ファイアウォールモードに関係なくブロック</span>
        </strong>
        <b-button class="pull-right" size="sm" variant="outline-info" @click="explain_ip_block_or_detect = true"><i class="fa fa-question"></i></b-button>
        <hr>
        <b-form-group>
          <b-form-textarea @update="block_ip($event, 'block_ip')" @change="block_ip" v-model="model.block_ip" :row="10" :max-rows="50"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="IPを許可"  class="modal-info" v-model="explain_ip_allow" ok-variant="success" header-bg-variant="success">
      <p>解析せずに通過するIPアドレスや範囲を設定することができます。</p>
      <p>ex ) 211.222.235.14</p>
    </b-modal>
    <b-modal title="IPアドレス管理"  class="modal-info" v-model="explain_ip_block_or_detect" ok-variant="success" header-bg-variant="warning">
      <p>解析せずにブロックするIPアドレスや範囲を設定することができます。</p>
      <p>例 ) 211.222.235.14</p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
